export const createEvent = ({ name, value }) => ({ target: { name, value } });

export const handleAccessibleEnter = ({ event, onChange, key }) => {
  if (key === 'Enter' || key === ' ') {
    onChange(event);
  }
};
